import React from "react";

export const FacebookIcon = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_275_319)">
        <path d="M10 0C15.5229 0 20 4.47715 20 10C20 14.9913 16.3432 19.1283 11.5625 19.8785V12.8906H13.8926L14.3359 10H11.5625V8.12414C11.5625 7.9118 11.5904 7.7009 11.6553 7.50598C11.802 7.0657 12.1372 6.70693 12.7655 6.59717C12.8949 6.57454 13.0369 6.5625 13.1921 6.5625H14.4531V4.10156C14.4531 4.10156 13.3088 3.90625 12.2146 3.90625C9.93043 3.90625 8.4375 5.29063 8.4375 7.79688V10H5.89844V12.8906H8.4375V19.8785C3.65687 19.1283 0 14.9913 0 10C0 4.47715 4.47715 0 10 0Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_275_319">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
